import { render, staticRenderFns } from "./DashboardChartGender.vue?vue&type=template&id=04cf2abb&scoped=true"
import script from "./DashboardChartGender.vue?vue&type=script&lang=js"
export * from "./DashboardChartGender.vue?vue&type=script&lang=js"
import style0 from "./DashboardChartGender.vue?vue&type=style&index=0&id=04cf2abb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cf2abb",
  null
  
)

export default component.exports